<template>
  <div id="account-profile-tab">
    <card-widget>
      <template #cardBody>
        <add-account-form show-form @set-account="setAccount" />
      </template>
    </card-widget>
  </div>
</template>

<script>
import CardWidget from "@/components/widgets/CardWidget.vue";
import AddAccountForm from "@/components/forms/AddAccountForm.vue";

/**
 * Account profile page
 */
export default {
  name: "AccountProfile",
  /**
   * Custom events
   */
  emits: ["set-account"],
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: { CardWidget, AddAccountForm },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * @emits set-account event in parent component to set account details
     */
    setAccount(account) {
      this.$emit("set-account", account);
    },
  },
};
</script>
